@if (isHomepage()) {
  <ng-container *ngTemplateOutlet="storeFinderInput"></ng-container>
} @else {
  <boels-vertical-aligner [innerWidth]="'wide'">
    <div class="boels-store-finder-search__container">
      <div class="boels-store-finder-search__label">
        {{ 'storeFinder.search.provideInput' | transloco }}
      </div>

      <div class="boels-store-finder-search__search-row">
        <ng-container *ngTemplateOutlet="storeFinderInput"></ng-container>
        <boels-store-finder-specialisms-dropdown></boels-store-finder-specialisms-dropdown>
        <button
          boelsButton
          [variant]="'primary-brand'"
          [action]="'none'"
          [shape]="'pill'"
          [icon]="faSearch"
          (click)="findStores($any(searchBox.value))"
          [isDisabled]="!searchInput ? true : !searchInput.value"
        >
          {{ 'storeFinder.search.search' | transloco }}
        </button>
      </div>
    </div>
  </boels-vertical-aligner>
  <boels-vertical-aligner
    [innerWidth]="'wide'"
    class="boels-store-finder-search__quick-actions__container"
  >
    <div class="boels-store-finder-search__quick-actions">
      <div class="boels-store-finder-search__quick-actions__action">
        <button
          (click)="viewStoresWithMyLoc()"
          class="btn btn-underline btn-underline-icon btn-underline-left"
        >
          <fa-icon [icon]="faLocationDot" size="sm"></fa-icon>
          <span>{{ 'storeFinder.search.searchByLocation' | transloco }}</span>
        </button>
      </div>
      <span class="boels-store-finder-search__quick-actions__separator"></span>
      <div class="boels-store-finder-search__quick-actions__action">
        <button
          (click)="scrollToAnchor('regions')"
          class="btn btn-underline btn-underline-right"
        >
          {{ 'storeFinder.search.searchByProvince' | transloco }}
        </button>
      </div>
    </div>
  </boels-vertical-aligner>
}

<ng-template #storeFinderInput>
  <boels-text-input
    [ngClass]="{ '-homepage': this.isHomepage() }"
    #searchInput
    id="store-finder"
    type="text"
    class="boels-store-finder-search__input"
    [withMargin]="false"
    [placeholder]="'storeFinder.search.placeholder' | transloco"
    (keyup)="onKey($event, $any(searchBox.value))"
    [formControl]="searchBox"
    [enterKeyHint]="'search'"
  ></boels-text-input>
</ng-template>
